<div class="relative height-min publication-cover">
  <a [href]="getPublicationDetailLink()" class="absolute">
    <uni-image
      classes="rounded-border sparro-bg-white fit-cover"
      [src]="publication?.cover ? publication.cover?.url : publication.cover_image?.url"
      [default]="defaultImage"
      [alt]="publication.title"
      [height]="192"
      [width]="144">
    </uni-image>
  </a> 
  <div class="absolute bottom-3 right-3 fx-row" *ngIf="showGeneralBadges">
    <div
        class="publication-badge"
        *ngIf="publication.likes">
        <i class="icon-like font-sm fx-contents badge-icon"></i>
        <span class="font-xxs badge-text">{{ publication.likes }}</span>
      </div>
      <div
        class="publication-badge"
        *ngIf="publication.comments">
        <i class="icon-comments font-sm fx-contents badge-icon"></i>
        <span class="font-xxs badge-text">{{ publication.comments }}</span>
      </div>
  </div>
</div>